import * as React from 'react';

import { Duration } from 'luxon';

export const Time: React.FC<{ value: number | string }> = ({ value }) => {
  const seconds = Math.round(Number(value)) || 0;
  return <>{seconds > 0 ? Duration.fromObject({ seconds }).toFormat('hh:mm:ss') : '--:--'}</>;
};
